export default "__VITE_ASSET__0T9CvBtx__"